import React from 'react';
import '../App.css';
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Landingpage() {
  return (
    <div className="landing-page">
      <main className="hero">
        <div className="hero-text">
          <img src="/anisparklargest.png" alt="AniSpark Logo" className="logo-image-small" />

          <h1>Watch short-form anime<br />from independent creators</h1>
          <div className="support-banner">Supporting indie anime creators</div>
          <Link to="/explore">
            <Button variant="primary" size="lg" className="mt-3">Browse Episodes</Button>
          </Link>
        </div>
        <div className="hero-image">
          <img src="/sparkyhappy.png" alt="Sparky the mascot" />
        </div>

        <div className="star-field">
          {Array.from({ length: 80 }).map((_, i) => (
            <div
              key={i}
              className="star"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>
      </main>
    </div>
  );
}
